import { NavLink } from 'react-router-dom'
import logo from '../assets/sumSystem_logo.png'
import { BsCreditCard, BsCardList } from 'react-icons/bs'
import { GoGlobe } from 'react-icons/go'
import { useAuthContext } from '../hooks/useAuthContext'

export default function DashboardPanel() {
	const { dispatch } = useAuthContext()

	const handleLogout = () => {
		dispatch({ type: 'LOGOUT' })
	}
	return (
		<div className='bg-gray-300 flex pt-16 mr-2 h-screen'>
			<div className='flex flex-col relative'>
				<div className='w-56 flex justify-center'>
					<img src={logo} alt='logo' className='h-20 object-contain' />
				</div>
				<div className='flex flex-col space-y-3 items-start my-10'>
					<NavLink
						to='/'
						className={({ isActive }) =>
							isActive ? 'activeBtn' : 'inActiveBtn'
						}>
						<div className='activeIcon'>
							<BsCreditCard />
						</div>
						<p>ADD NEW CARD</p>
					</NavLink>
					<NavLink
						to='/cards'
						className={({ isActive }) =>
							isActive ? 'activeBtn' : 'inActiveBtn'
						}>
						<div className='activeIcon'>
							<BsCardList />
						</div>
						<p>CARD LIST</p>
					</NavLink>
					<NavLink
						to='/countries'
						className={({ isActive }) =>
							isActive ? 'activeBtn' : 'inActiveBtn'
						}>
						<div className='activeIcon'>
							<GoGlobe />
						</div>
						<p>COUNTRY LIST</p>
					</NavLink>
				</div>
				<div className='absolute p-2 bottom-5'>
					<div className='bg-gray-200 rounded-md p-4 flex text-gray-500 flex-col items-center justify-center'>
						<p className='text-xs'>Platform notifications</p>
						<p className='my-2 text-black'>System Updates</p>
						<p className='text-xs'>New security updates added!</p>
						<button
							onClick={handleLogout}
							className='text-white items-center justify-center flex mt-3 p-1 w-36 rounded-lg bg-gray-400'>
							logout
						</button>
					</div>
				</div>
			</div>
		</div>
	)
}
